var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteTwitchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5864,
    y: 12.2405,
    width: 1.34182,
    height: 3.48874,
    fill: "#180F24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.075,
    y: 12.2405,
    width: 1.34182,
    height: 3.48874,
    fill: "#180F24"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1519,
    y: 8.75146,
    width: 13.4853,
    height: 1.27473,
    fill: "#180F24"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.085,
    y: 8.75146,
    width: 1.20764,
    height: 12.546,
    fill: "#180F24"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5637,
    y: 8.75146,
    width: 1.20764,
    height: 9.12439,
    fill: "#180F24"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2251,
    y: 20.157,
    width: 2.21401,
    height: 1.14055,
    fill: "#180F24"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2986,
    y: 20.157,
    width: 1.20764,
    height: 4.56219,
    fill: "#180F24"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5063,
    y: 23.5115,
    width: 1.14055,
    height: 1.20764,
    fill: "#180F24"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4233,
    y: 17.876,
    width: 1.14055,
    height: 1.14055,
    fill: "#180F24"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2827,
    y: 19.0161,
    width: 1.14055,
    height: 1.14055,
    fill: "#180F24"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7874,
    y: 21.2971,
    width: 1.14055,
    height: 1.14055,
    fill: "#180F24"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.647,
    y: 22.4382,
    width: 1.14055,
    height: 1.14055,
    fill: "#180F24"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8608,
    y: 20.157,
    width: 3.42165,
    height: 1.20764,
    fill: "#180F24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTwitchIcon);
export default __webpack_public_path__ + "static/media/white-twitch-icon.47ead8fb92408326102d2b4127dbf55b.svg";
export { ForwardRef as ReactComponent };